/**************************************************
 * Nombre:       Detalle_Condiciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Condiciones from "../../Tarjetas/Tarjeta_Condiciones";

const Detalle_Condiciones = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={1}
                    >

                        {itemsDos.map((item, i) => (
                            <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Condiciones/>
                            </Grid>
                        ))}


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Condiciones

const itemsDos = [1,2,3]